/**
 * Admin Dashboard Contracts - Database-First Zod Schemas
 *
 * SOURCE OF TRUTH: PostgreSQL queries in backend/src/controllers/admin/dashboard.controller.ts
 * Generated from MCP queries on 2026-01-02
 *
 * The dashboard stats are aggregations from multiple tables:
 * - users (total, active, banned, registered today)
 * - deposits (totals, pending, completed today)
 * - withdrawals (totals)
 */
import { z } from 'zod';
// =============================================================================
// DASHBOARD STATS SCHEMA
// =============================================================================
/**
 * GET /api/admin/dashboard response data
 * Matches backend controller response
 *
 * NOTE: DashboardResponse is returned directly, NOT wrapped in { stats: ... }
 */
export const dashboardResponseDataSchema = z.object({
    users: z.object({
        total: z.number().int(),
        active: z.number().int(),
        banned: z.number().int(),
        registeredToday: z.number().int(),
    }),
    finance: z.object({
        totalDeposits: z.number().int(),
        totalWithdrawals: z.number().int(),
        profit: z.number().int(), // totalDeposits - totalWithdrawals
        todayDeposits: z.number().int(),
        todayWithdrawals: z.number().int(),
    }),
    deposits: z.object({
        pending: z.number().int(),
        completedToday: z.number().int(),
    }),
    system: z.object({
        dbConnected: z.boolean(),
        redisConnected: z.boolean(),
    }),
});
// =============================================================================
// TURNOVER REPORT SCHEMA
// =============================================================================
/**
 * Period values for turnover report
 */
export const turnoverPeriodValues = ['weekly', 'monthly', 'yearly'];
export const turnoverPeriodSchema = z.enum(turnoverPeriodValues);
/**
 * GET /api/admin/reports/turnover response data
 * Matches backend controller response
 *
 * NOTE: Returned directly, NOT wrapped in { report: ... }
 */
export const turnoverReportResponseDataSchema = z.object({
    period: turnoverPeriodSchema,
    days: z.number().int(),
    deposits: z.object({
        count: z.number().int(),
        amount: z.number().int(),
    }),
    withdrawals: z.object({
        count: z.number().int(),
        amount: z.number().int(),
    }),
    net: z.number().int(), // deposits.amount - withdrawals.amount
    newUsers: z.number().int(),
});
/**
 * GET /api/admin/reports/turnover query params
 */
export const turnoverReportQuerySchema = z.object({
    period: turnoverPeriodSchema.optional().default('monthly'),
});
//# sourceMappingURL=dashboard.js.map